import toast from 'react-hot-toast';

export const prepareFunctionArguments = (
  tool,
  currentToolResponseForReference,
) => {
  // Default: return the original arguments string untouched
  if (
    tool.function.name !==
    'performCRUDOperationsOnUserFilesAndGenerateDataVisualizations'
  ) {
    return tool.function.arguments;
  }

  let parsedArgs = {};
  try {
    parsedArgs = JSON.parse(tool.function.arguments);
  } catch (err) {
    return tool.function.arguments; // Fallback to original
  }

  const scriptStr = parsedArgs?.script_str;
  if (typeof scriptStr === 'string') {
    const regex = /\$\{tool_responses\.(.*?)\}/g;
    const matches = new Set();
    let match;
    while ((match = regex.exec(scriptStr)) !== null) {
      matches.add(match[1]);
    }

    if (matches.size > 0) {
      const previousToolResponses = {};
      matches.forEach((id) => {
        if (currentToolResponseForReference[id]) {
          previousToolResponses[id] = currentToolResponseForReference[id];
        }
      });
      parsedArgs.previous_tool_responses = previousToolResponses;
    }
  }

  return JSON.stringify(parsedArgs);
};

export const extractAndSetToolResponsesForReferencing = (
  data,
  setCurrentToolResponseForReference,
) => {
  if (data && typeof data.content === 'string') {
    try {
      const parsed = JSON.parse(data.content);

      if (
        typeof parsed === 'object' &&
        parsed !== null &&
        parsed.hasOwnProperty('tool_response') &&
        parsed.hasOwnProperty('response_type') &&
        parsed.hasOwnProperty('tool_response_id')
      ) {
        // Save to state: tool_response_id => tool_response
        setCurrentToolResponseForReference((prev) => ({
          ...prev,
          [parsed.tool_response_id]: JSON.stringify(parsed.tool_response),
        }));
      }
    } catch (err) {
      toast.error('Failed to parse tool response for referencing.');
    }
  }
};
